<div *ngIf="content" class="section-box">
  <h2 class="section-title" i18n="@@currencyDetail.whyTrade.title">Why Trade {{ currencyName }} on BitOasis</h2>
  <div class="section-content" [innerHTML]="content | safeHtml"></div>
</div>
